import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { State } from '../redux';

const PointsFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['awardConfiguration']['pointAward'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};
const PointAward: React.FC<Props> = (props) => {
  const { fieldDisabled, points } = props;

  return (
    <Box>
      <Box my={4}>
        <PointsFormInput
          id='points'
          label='Points to Award'
          readonly={fieldDisabled('points')}
          type='text'
          value={points}
          required={true}
        />
      </Box>
    </Box>
  );
};

export { PointAward };
